const mode = "live";
const site = "unsat";
const siteUrl = process.env.REACT_APP_TUNINGFORK_URL || "https://" + site + ".edusquares.com/";
// const siteUrl = "http://localhost:8080/tuningfork/";

// const siteUrl = "https://erp.nttftrg.com/" // for nttf

const nodeSiteUrl = process.env.REACT_APP_NODE_API || `https://${site}-node.edusquares.com/api/`;
// const nodeSiteUrl = `http://localhost:8080/api/`

// Authentication backend selection ('java' or 'node')
const authBackend = process.env.REACT_APP_AUTH_BACKEND || 'java';
// For node backend, use nodeSiteUrl with v1 prefix; for java, use siteUrl
const authBaseUrl = authBackend === 'node' ? nodeSiteUrl + 'v1/' : siteUrl;

// Base configuration
const BaseConfig = {
    siteTitle: site,
    siteMode:  mode,
    siteUrl :  siteUrl,
    nodeSiteUrl,
    authBackend,
    authBaseUrl,
    baseUrl :  siteUrl + 'rest/mobile/',
    apiUrl  :  siteUrl + 'rest/mobile/ilearn/',
    getGamePlay: siteUrl + 'api/common/game/gameplays',
    getBatch: siteUrl + 'api/common/batches?',
    getBatchforEnquiry: siteUrl + 'api/common/enquiry/',
    getLearnersforBatchId :  siteUrl + 'api/common/batches/',
    logo    :  "https://webfront.edusquares.com/" + site + "/files/pwa/logo.jpg",
    cover   :  "https://webfront.edusquares.com/" + site + "/files/pwa/cover.jpg",
    pdfUrl  :  siteUrl,
    desktopApi  :  siteUrl + 'api/',
    AWSRegion: "ap-southeast-1",
    AWSEndpoint: '',
    AWSAccessKeyId: "",
    AWSSecretAccessKey: "",
    CONNECTION_ERROR_MSG: "The server is taking too long to respond OR something is wrong with your internet connection. Please try again later.",

    // GIGW Compliance Configuration
    gigwMode: false, // Set to true to enable GIGW compliance features

    // Organization Configuration (used when gigwMode is enabled)
    organization: {
        type: "private", // "government", "educational", "private"
        name: site + " Learning Platform",
        contactEmail: "support@" + site + ".com",
        privacyEmail: "privacy@" + site + ".com",
        supportPhone: "+91-40-4020-4020",
        address: "Learning Platform Address",
        dpoName: "Data Protection Officer",
        companyName: "Your Company Name",

        // Government specific fields (only used when type is "government")
        governmentEmblem: "/assets/images/govt-emblem.png",
        ministryName: "Ministry Name",
        departmentName: "Department Name",
        govtWebsiteUrl: "https://ministry.gov.in"
    },

    // Feature toggles for GIGW compliance
    features: {
        mandatoryPages: false, // Privacy Policy, Terms, Grievance, About Us
        lastUpdatedTimestamps: false, // Show last updated dates
        contentOwnership: false, // Show content owner information
        multiLanguage: false, // Hindi + regional language support
        governmentBranding: false, // Government logos and branding
        apiIntegration: false, // Government API integration readiness
        accessibilityEnhanced: true, // Always enabled - WCAG compliance
        grievancePortal: false, // Formal grievance redressal system
        archivePolicy: false // Content archival and version management
    }
};

// Merge with test override if available (for development/testing)
const Config = (() => {
    if (typeof window !== 'undefined' && window.GIGW_TEST_OVERRIDE) {
        return {
            ...BaseConfig,
            ...window.GIGW_TEST_OVERRIDE,
            organization: {
                ...BaseConfig.organization,
                ...window.GIGW_TEST_OVERRIDE.organization
            },
            features: {
                ...BaseConfig.features,
                ...window.GIGW_TEST_OVERRIDE.features
            }
        };
    }
    return BaseConfig;
})();

export const OpenLoginTypes = {
    //Open Login Types
    OPEN_LOGIN_TYPE_FACEBOOK : 1,
    OPEN_LOGIN_TYPE_GOOGLE : 2 
}

const CURRENT_PORTLET = null;

export default Config;